import type { ProjectStatus, ProjectPriority } from '@/types/project';

export const getStatusColor = (status: ProjectStatus) => {
  switch (status) {
    case 'active':
      return 'bg-success-500/10 text-success-700 dark:text-success-400 border-success-500/20';
    case 'at-risk':
      return 'bg-warning-500/10 text-warning-700 dark:text-warning-400 border-warning-500/20';
    case 'on-hold':
      return 'bg-neutral-500/10 text-neutral-700 dark:text-neutral-400 border-neutral-500/20';
    default:
      return 'bg-info-500/10 text-info-700 dark:text-info-400 border-info-500/20';
  }
};

export const getPriorityColor = (priority: ProjectPriority) => {
  switch (priority) {
    case 'high':
      return 'bg-error-500/10 text-error-700 dark:text-error-400 border-error-500/20';
    case 'medium':
      return 'bg-info-500/10 text-info-700 dark:text-info-400 border-info-500/20';
    case 'low':
      return 'bg-neutral-500/10 text-neutral-700 dark:text-neutral-400 border-neutral-500/20';
  }
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
